import { BrowserRouter } from 'react-router-dom';
import { LocalizationProvider as LocalizationProviderPro } from '@mui/x-date-pickers-pro';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns as AdapterDateFnsPro } from '@mui/x-date-pickers-pro/AdapterDateFnsV3';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { SnackbarProvider } from 'notistack';

import { el } from 'date-fns/locale/el';

import AppRoutes from './routes';
import { BASE_URL } from 'config';
import { hasAuthParams, useAuth } from 'react-oidc-context';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { Backdrop, CircularProgress } from '@mui/material';
import { useInitializeUser } from 'hooks/useInitializeUser';

import 'react-big-calendar/lib/css/react-big-calendar.css';

const App = () => {
  const auth = useAuth();
  const [hasTriedSignIn, setHasTriedSignIn] = useState(false);

  const userConfigLoaded = useInitializeUser(auth.isAuthenticated);

  useEffect(() => {
    if (!hasTriedSignIn && !hasAuthParams() && !auth.isAuthenticated && !auth.activeNavigator && !auth.isLoading) {
      auth.signinRedirect();
      setHasTriedSignIn(true);
    }
  }, [auth, hasTriedSignIn]);

  if (auth.isLoading) {
    return (
      <Backdrop open style={{ zIndex: 9999, color: '#fff', backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
        <CircularProgress color="inherit" />
      </Backdrop>
    );
  }

  if (!auth.isAuthenticated) {
    console.error(auth.error);
    return <div>Unable to log in</div>;
  }

  if (!userConfigLoaded) {
    return (
      <Backdrop open style={{ zIndex: 9999, color: '#fff', backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
        <CircularProgress color="inherit" />
      </Backdrop>
    );
  }

  return (
    <>
      <BrowserRouter basename={BASE_URL}>
        <LocalizationProviderPro dateAdapter={AdapterDateFnsPro} adapterLocale={el}>
          <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={el}>
            <SnackbarProvider anchorOrigin={{ horizontal: 'right', vertical: 'top' }} maxSnack={5} dense>
              <AppRoutes />
            </SnackbarProvider>
          </LocalizationProvider>
        </LocalizationProviderPro>
      </BrowserRouter>
    </>
  );
};

export default App;
